import { VariationTypeEnum } from "@utilities/enums";
import { Color, ColorSizeEntry, Size, Variations } from "@utilities/types";

export function isNoneVariation(variations: Variations): variations is { quantity: number } {
    return 'quantity' in variations;
}

export function isSizeVariation(variations: Variations): variations is { sizes: Size[] } {
    return 'sizes' in variations;
}

export function isColorVariation(variations: Variations): variations is { colors: Color[] } {
    return 'colors' in variations;
}

export function isBothVariation(variations: Variations): variations is { colorSizeData: ColorSizeEntry[] } {
    return 'colorSizeData' in variations;
}

export const buildVariationsByType = (
    variationType: VariationTypeEnum,
    data: any
): Variations => {
    switch (variationType) {
        case VariationTypeEnum.NONE:
            if (typeof data === 'number') {
                return { quantity: data };
            } else if (data && typeof data.quantity === 'number') {
                return { quantity: data.quantity };
            }
            return { quantity: 0 };

        case VariationTypeEnum.SIZE:
            if (data && Array.isArray(data) && data.length > 0 && 'size' in data[0]) {
                return { sizes: data };
            }
            else if (data && Array.isArray(data.sizes)) {
                return { sizes: data.sizes };
            }
            return { sizes: [] };

        case VariationTypeEnum.COLOR:
            if (data && Array.isArray(data) && data.length > 0 && 'color' in data[0]) {
                return { colors: data };
            }
            else if (data && Array.isArray(data.colors)) {
                return { colors: data.colors };
            }
            return { colors: [] };

        case VariationTypeEnum.BOTH:
            if (data && Array.isArray(data) && data.length > 0 && 'color' in data[0] && 'sizes' in data[0]) {
                return { colorSizeData: data };
            }
            else if (data && Array.isArray(data.colorSizeData)) {
                return { colorSizeData: data.colorSizeData };
            }
            return { colorSizeData: [] };

        default:
            return { quantity: 0 };
    }
};

export const getVariationType = (variations: Variations): VariationTypeEnum => {
    if ('quantity' in variations) {
        return VariationTypeEnum.NONE;
    } else if ('sizes' in variations) {
        return VariationTypeEnum.SIZE;
    } else if ('colors' in variations) {
        return VariationTypeEnum.COLOR;
    } else {
        return VariationTypeEnum.BOTH;
    }
}
